import { render, staticRenderFns } from "./DrugBatchLogItem.vue?vue&type=template&id=60bad0c8&scoped=true&lang=pug&"
import script from "./DrugBatchLogItem.vue?vue&type=script&lang=ts&"
export * from "./DrugBatchLogItem.vue?vue&type=script&lang=ts&"
import style0 from "./DrugBatchLogItem.vue?vue&type=style&index=0&id=60bad0c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bad0c8",
  null
  
)

export default component.exports